import React from 'react';
import { cn } from '../../lib/utils';

interface BadgeProps {
  status: string;
  className?: string;
}

const statusStyles: Record<string, string> = {
  ACTIVE: 'd-badge-active',
  COMPLETED: 'd-badge-completed',
  APPROVED: 'd-badge-completed',
  PENDING: 'd-badge-pending',
  PROCESSING: 'd-badge-pending',
  REJECTED: 'd-badge-rejected',
  FAILED: 'd-badge-rejected',
  INACTIVE: 'd-badge-inactive',
  SUSPENDED: 'd-badge-suspended',
  CANCELLED: 'd-badge-rejected',
  OPEN: 'd-badge-pending',
  CLOSED: 'd-badge-inactive',
  VERIFIED: 'd-badge-active',
  NOT_SUBMITTED: 'd-badge-inactive',
  REQUIRED: 'd-badge-pending',
  ROI_EARNING: 'd-badge-completed',
  DIRECT: 'd-badge-completed',
  DIRECT_COMMISSION: 'd-badge-completed',
  LEVEL: 'd-badge-completed',
  LEVEL_INCOME: 'd-badge-completed',
  DEPOSIT: 'd-badge-completed',
  WITHDRAWAL: 'd-badge-pending',
  INVESTMENT: 'd-badge-completed',
  BONUS: 'd-badge-completed',
};

export default function Badge({ status, className }: BadgeProps) {
  const style = statusStyles[status] || 'd-badge-inactive';
  return (
    <span className={cn(style, className)}>
      {status?.replace(/_/g, ' ')}
    </span>
  );
}
